














































































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import MailNotifyTemplate from '@/pages/Pages/Templates/MailNotifyTemplate.vue'
import { MsgTransports } from '@/store/types';
import { SelectWings } from "wings-ui-components";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericDistribution, MailNotifyTemplate, SelectWings}})
export default class MailNotifyDistribution extends GenericDistribution {

  @Getter("mnServices") mnServices: any;

  transport = MsgTransports.MAILNOTIFY

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }

  get mnServiceName() {
    return this.mnServices.find((item:any) => item.id == this.template.mnServiceId)?.mnServiceName
  }

  get mnTemplateName() {
    return this.mnServices.find((item:any) => item.id == this.template.mnServiceId)
      ?.mnTemplates.find((item:any) => item.id == this.template.mnTemplateId)?.tmpl
  }

}
